import React, { useState } from "react";
import toast from "react-hot-toast";
import { Button, Input, Typography } from "@material-tailwind/react";
import { portalApi } from "../services/portalApi";

export default function RevistaSubscribeForm({ source = "landing", compact = false }) {
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [consent, setConsent] = useState(false);
  const [submitting, setSubmitting] = useState(false);
  const [done, setDone] = useState(false);

  async function onSubmit(e) {
    e.preventDefault();
    if (!consent) {
      toast.error("Debes aceptar el aviso de privacidad");
      return;
    }
    setSubmitting(true);
    try {
      const r = await portalApi.revistaSubscribe({ name, email, consent, source });
      setDone(true);
      toast.success(r?.message || "Revisa tu correo para descargar la revista");
    } catch (err) {
      toast.error(err?.message || "No se pudo enviar la suscripción");
    } finally {
      setSubmitting(false);
    }
  }

  if (done) {
    return (
      <div className="rounded-xl border border-brand-lavender/25 bg-brand-lilac/20 p-5">
        <Typography className="font-semibold text-brand-dark">
          Listo — revisa tu bandeja
        </Typography>
        <p className="text-sm text-brand-gray mt-1 leading-relaxed">
          Si el correo es válido, recibirás el link de descarga en breve (también revisa spam).
        </p>
      </div>
    );
  }

  return (
    <form onSubmit={onSubmit} className={compact ? "space-y-3" : "space-y-4"}>
      <Input
        label="Nombre"
        value={name}
        onChange={(e) => setName(e.target.value)}
        required
        containerProps={{ className: "min-w-0" }}
      />
      <Input
        type="email"
        label="Correo electrónico"
        value={email}
        onChange={(e) => setEmail(e.target.value)}
        required
        containerProps={{ className: "min-w-0" }}
      />
      <label className="flex items-start gap-2 text-sm text-brand-gray cursor-pointer">
        <input
          type="checkbox"
          className="mt-1 rounded border-brand-brown/40"
          checked={consent}
          onChange={(e) => setConsent(e.target.checked)}
        />
        <span>
          Acepto el aviso de privacidad y deseo recibir Conexión Siete por correo.
        </span>
      </label>
      <Button
        type="submit"
        disabled={submitting}
        className="bg-brand-lavender text-white normal-case shadow-md shadow-brand-lavender/25"
      >
        {submitting ? "Enviando…" : "Suscribirme y recibir PDF"}
      </Button>
    </form>
  );
}
